import {
  IAlbum,
  IAlbumMetaData,
  IMerchandiseMetadata,
} from '../data/models/album';
import { ISalesProjection } from '../data/models/salesProjection';
import { IManufacturing } from '../data/models/manufacturing';
import _ from 'lodash';
import { AlbumState } from '../data/models/albumState';
import { IFormat } from '@/data/models/format';
import { TrackType } from '@/data/models/track';
import { isVideoFormat } from '@/utils/helper';

// contains logic to clone and clear out specific fields from source album
export function duplicateAlbum(
  sourceAlbum: IAlbum,
  newTitle: string,
  newFormat: IFormat | null
): IAlbum {
  const newAlbum = _.cloneDeep(sourceAlbum) as IAlbum;
  newAlbum.title = newTitle;
  newAlbum.format = newFormat;

  delete newAlbum.id;
  delete newAlbum.gtin;
  delete newAlbum.catalogNumber;
  delete newAlbum.packaging;
  newAlbum.albumState = AlbumState.Draft;

  const albumMetaData = newAlbum?.albumMetaData as IAlbumMetaData;
  if (albumMetaData) {
    delete albumMetaData.boxCount;
    delete albumMetaData.unitsPerSets;
    albumMetaData.stateHistory = [];
  }

  if (sourceAlbum.format?.name !== newAlbum.format?.name) {
    const merchandiseMetadata =
      newAlbum?.merchandiseMetadata as IMerchandiseMetadata;
    if (merchandiseMetadata) {
      delete merchandiseMetadata.merchandiseType;
    }
  }

  const sales = newAlbum?.albumMetaData?.salesProjection as ISalesProjection;
  if (sales) {
    sales.projectedPhysicalIO = null;
  }

  const manufacturing = newAlbum?.albumMetaData
    ?.manufacturing as IManufacturing;
  if (manufacturing) {
    manufacturing.manufacturingCostPerUnit = null;
    manufacturing.currency = null;
  }

  const sourceIsVideoFormat = isVideoFormat(sourceAlbum.format?.name);
  const targetIsVideoFormat = isVideoFormat(newFormat?.name);

  newAlbum.tracks.forEach((t) => {
    delete t.albumId;
    delete t.id;

    if (!targetIsVideoFormat) {
      t.trackType = null;
    } else if (!sourceIsVideoFormat) {
      t.trackType = TrackType.VideoAndAudio;
    }
  });

  return newAlbum;
}
